export default __webpack_public_path__ + "static/media/default-profile.20a8d31a.svg";